<template>
    <div class="reset-password-page">

        <Panel>
            <div class="reset-form login-form" v-if="!isSetupSuccessful && !isSetupExpired">
                <PasswordChangeForm
                    :error-message="errorMessage"
                    :current-password-required="false"
                    :is-processing="isLoading"
                    title="Setup your password"
                    change-password-label="Setup Password"
                    @change-password="handleSetupRequest"
                />
            </div>
            <div v-else-if="isSetupExpired">
                <h1>Setup your password</h1>
                <Alert type="danger" message="The password setup request has expired. Please request a password reset." />

                <a href="javascript:void(0)" @click="handleResetPassword()">
                    Reset your password
                </a>
            </div>
            <div v-else>
                <Alert type="success" message="You have successfully setup your password." />

                <a href="/">Go to Login</a>
            </div>
        </Panel>

    </div>
</template>

<script>
import {useLoading} from "@/hooks/use-loading";
import {setupPasswordViaToken} from "@/api/user";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref} from "vue";

import Panel from "@/components/Panel";
import PasswordChangeForm from "@/pages/common/PasswordChangeForm";
import Alert from "@/components/Alert";
import {userState} from "@/stores/user";
import {paramsState} from "@/stores/params";

export default {
    name: "ConfirmSetupPasswordPage",
    components: {
        Alert,
        PasswordChangeForm,
        Panel,
    },
    setup() {
        const {isLoading, startLoading, stopLoading} = useLoading(false);

        const isSetupSuccessful = ref(false);
        const isSetupExpired = ref(false);

        const errorMessage = ref('');

        const route = useRoute();
        const router = useRouter();

        onMounted(() => {
            if (userState.isLoggedIn) {
                router.push("/");
            }

          const parts = route.query.token.split(':');

          if(typeof parts[1] === 'undefined' || (Date.now() / 1000 - parseInt(parts[1])) > paramsState.setupPasswordValidForSeconds) {
              isSetupExpired.value = true;
          }
        });

        const handleSetupRequest = async ({new_password}) => {
            errorMessage.value = '';
            startLoading();

            try {
                await setupPasswordViaToken({
                    token: route.query.token,
                    new_password
                });

                isSetupSuccessful.value = true;
            } catch (e) {
                errorMessage.value = e?.response?.data?.message ?? e.message;
            } finally {
                stopLoading();
            }
        };

        const handleResetPassword = () => {
            router.push('/reset-request');
        };

        return {
            isLoading,
            isSetupSuccessful,
            isSetupExpired,
            errorMessage,
            handleSetupRequest,
            handleResetPassword,
        };
    }
}
</script>